import { TokenSessionManager } from '@lib/http';

export type OptionalSessionManager = TokenSessionManager | null;

let manager: OptionalSessionManager = null;

export const setManager = (newOne: OptionalSessionManager) => {
  manager = newOne;
};

export const getManager = (): OptionalSessionManager => {
  return manager;
};

export const getActiveManager = (): TokenSessionManager => {
  if (!manager) {
    throw new Error('SessionManager has not been set');
  }

  return manager;
};

export const setupManager = (): TokenSessionManager => {
  const tokenClient = new TokenSessionManager(import.meta.env.VITE_API_URL);

  setManager(tokenClient);

  return tokenClient;
};
